"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayTimeoutError = exports.BadGatewayError = exports.InternalServerError = exports.NotFoundError = exports.ExpiredInvitationError = exports.InvalidInvitationSecretError = exports.InvalidInvitationError = exports.InvalidParameterError = exports.GenericError = void 0;
const core_1 = require("@smash-sdk/core");
class GenericError extends core_1.SDKError {
}
exports.GenericError = GenericError;
class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
exports.InvalidParameterError = InvalidParameterError;
class InvalidInvitationError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidInvitationError";
    }
}
exports.InvalidInvitationError = InvalidInvitationError;
class InvalidInvitationSecretError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidInvitationSecretError";
    }
}
exports.InvalidInvitationSecretError = InvalidInvitationSecretError;
class ExpiredInvitationError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ExpiredInvitationError";
    }
}
exports.ExpiredInvitationError = ExpiredInvitationError;
class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
exports.NotFoundError = NotFoundError;
class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
exports.InternalServerError = InternalServerError;
class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
exports.BadGatewayError = BadGatewayError;
class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
exports.GatewayTimeoutError = GatewayTimeoutError;
exports.default = {
    GenericError,
    InvalidParameterError,
    InvalidInvitationError,
    InvalidInvitationSecretError,
    ExpiredInvitationError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
